import { createReducer, isAnyOf } from '@reduxjs/toolkit';
import {
  CLEAR_SOFTWARE_RELEASE,
  CLEAR_SOFTWARE_RELEASES,
  CREATE_SOFTWARE_RELEASE,
  DELETE_SOFTWARE_RELEASE,
  GET_SOFTWARE_RELEASE,
  GET_SOFTWARE_RELEASES,
  UPDATE_SOFTWARE_RELEASE,
} from '../actions/software-releases';

type Paginated<T> = {
  rows: T[];
  count: number;
  pagination: {
    current: number;
    per_page: number;
  };
};

type SoftwareRelease = unknown;

export type SoftwareReleaseState = {
  softwareReleases: Paginated<SoftwareRelease>;
  softwareRelease: SoftwareRelease;
};

const initState: SoftwareReleaseState = {
  softwareReleases: { rows: [], count: 0, pagination: { current: 1, per_page: 30 } },
  softwareRelease: {},
};

const softwareReleaseReducer = createReducer(initState, (builder) =>
  builder
    .addCase(CLEAR_SOFTWARE_RELEASES, (state) => {
      return { ...state, softwareReleases: initState.softwareReleases };
    })
    .addCase(CLEAR_SOFTWARE_RELEASE, (state) => {
      return { ...state, softwareRelease: initState.softwareRelease };
    })
    .addCase(GET_SOFTWARE_RELEASES, (state, action) => {
      return { ...state, softwareReleases: action.payload };
    })
    .addCase(DELETE_SOFTWARE_RELEASE, (state) => ({ ...state }))
    .addMatcher(
      isAnyOf(CREATE_SOFTWARE_RELEASE, UPDATE_SOFTWARE_RELEASE, GET_SOFTWARE_RELEASE),
      (state, action) => ({ ...state, softwareRelease: action.payload })
    )
);

export default softwareReleaseReducer;
